// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2EeVJ","content":"Consent_content__3C9vH","footer":"Consent_footer__3nW7X"};